import React, { Component } from 'react';
import { CookiesProvider } from 'react-cookie';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setUser } from '../lib/datadogRum';
import App from '../components/App';
import {
  releaseNumber,
  getUserInfo,
  getCallingRooms,
} from '../actions/api/apis';
import {
  checkCompatible,
  isServiceVendor,
  isInitialRole,
  requestNotificationPermission,
} from '../lib/tools';

const INTERVAL_TIMER = 10000;

const updateContainer = (apiToken, dispatch, innerRole, isRemote) => {
  if (dispatch && apiToken && !isInitialRole(innerRole)) {
    if (!isServiceVendor(innerRole) && !isRemote) {
      dispatch(getCallingRooms(apiToken));
    }
    dispatch(getUserInfo(apiToken));
  }
};

// TODO APPの描画直前に何かしたかったらここに書く
class AppContainer extends Component {
  constructor(props) {
    super(props);
    const { dispatch, apiToken, calendarData } = props;
    const openCalendar = !!(calendarData && calendarData.name);
    const canUpdate =
      !openCalendar ||
      (props && !props.showUserPrompt) ||
      (props && props.isLogin);
    const compatibleInfo = checkCompatible();
    if (dispatch && apiToken) {
      dispatch(releaseNumber(apiToken));
      // activation時にエラーとなるため他のAPIは発行しない
      if (!canUpdate) {
        this.closeTimer();
      }
    }
    if (compatibleInfo.isAndroid) {
      dispatch({ type: 'SET_ALLOW_REMOTE_SUPPORT', allowRemoteSupport: false });
    } else {
      dispatch({ type: 'SET_ALLOW_REMOTE_SUPPORT', allowRemoteSupport: true });
    }
    // TODO iOSの場合は window.screen.orientation.onchangeでも取れる
    // onResizeで iOS/Androidどちらでも取れそう
    // ただし onResizeはソフトウェアキーボードでも発火するので注意
    if (window.addEventListener) {
      window.addEventListener(
        'resize',
        () => {
          const compatibleInfo2 = checkCompatible();
          if (compatibleInfo2.isAndroid) {
            // AndroidOSの場合のみ遠隔支援不可
            dispatch({
              type: 'SET_ALLOW_REMOTE_SUPPORT',
              allowRemoteSupport: false,
            });
          } else {
            dispatch({
              type: 'SET_ALLOW_REMOTE_SUPPORT',
              allowRemoteSupport: true,
            });
          }
          dispatch({
            type: 'UPDATE_COMPATIBLE_INFO',
            compatibleInfo: compatibleInfo2,
          });
        },
        false,
      );
    }
    if (document.addEventListener) {
      // タブがバックグラウンドの場合のみNotificationApiでの通知をするか
      // document.addEventListener('visibilitychange', () => {
      //   if (document.visibilityState === 'visible') {
      //     dispatch({ type: 'SET_SF_TAB_VISIBLE', sfTabVisible: true });
      //   } else {
      //     dispatch({ type: 'SET_SF_TAB_VISIBLE', sfTabVisible: false });
      //   }
      // });
      // ソフトウェアキーボードの検出はinput type=textにフォーカスがあるかないかで代替
      // isPC=trueでisForcusText=trueの場合でisOverHightLimit=trueの場合はタブレット
      document.addEventListener(
        'DOMFocusIn',
        e => {
          const isForcusText = e.target && e.target.type === 'text';
          dispatch({ type: 'SET_FORCUS_TEXT', isForcusText });
        },
        false,
      );
      document.addEventListener(
        'DOMFocusOut',
        () => {
          dispatch({ type: 'SET_FORCUS_TEXT', isForcusText: false });
        },
        false,
      );
    }
    // LocalStorageから検索条件読み込み
    dispatch({ type: 'LOAD_SEARCH_CRITERIA' });
    // browserの通知許可取得
    requestNotificationPermission();
  }

  shouldComponentUpdate(props) {
    const openCalendar = !!(
      props &&
      props.calendarData &&
      props.calendarData.name
    );
    const params = {
      dispatch: (props && props.dispatch) || null,
      apiToken: props && props.apiToken,
      isLogin: props && props.isLogin,
      showUserPrompt: props && props.showUserPrompt,
      innerRole: props && props.innerRole,
      operatorId: props && props.operatorId,
      isRemote: props && props.isRemote,
      openCalendar,
      stopApiCallTimer: props && props.stopApiCallTimer,
    };
    // RUMユーザー情報設定
    if (params.operatorId) {
      setUser(params.operatorId);
    }
    if (params.isLogin) {
      this.initialTimer(params);
    } else {
      this.closeTimer();
    }
    return true;
  }

  componentWillUnmount() {
    this.closeTimer();
  }

  initialTimer(params) {
    const {
      isLogin,
      dispatch,
      apiToken,
      showUserPrompt,
      innerRole,
      isRemote,
      openCalendar,
      stopApiCallTimer,
    } = params;
    this.closeTimer();
    if (dispatch && apiToken && isLogin && !showUserPrompt && !openCalendar) {
      updateContainer(apiToken, dispatch, innerRole, isRemote);
      this.mainTimer = setInterval(() => {
        if (!showUserPrompt && !openCalendar && !stopApiCallTimer) {
          updateContainer(apiToken, dispatch, innerRole, isRemote);
        }
      }, INTERVAL_TIMER);
    }
  }

  closeTimer() {
    if (this.mainTimer !== undefined) {
      clearInterval(this.mainTimer);
      delete this.mainTimer;
    }
  }

  render() {
    return (
      <CookiesProvider>
        <App />
      </CookiesProvider>
    );
  }
}

AppContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  innerRole: PropTypes.number.isRequired,
  operatorId: PropTypes.number.isRequired,
  isLogin: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
  isRemote: PropTypes.bool.isRequired,
  calendarData: PropTypes.object.isRequired,
  stopApiCallTimer: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  innerRole: state.main.innerRole,
  operatorId: state.main.userInfo.operatorId,
  isLogin: state.main.isLogin,
  apiToken: state.main.apiToken,
  companyRefreshPage: state.company.refreshPage,
  staffRefreshPage: state.operator.refreshPage,
  showUserPrompt: state.userPrompt.showUserPrompt,
  isRemote: state.room.isRemote,
  calendarData: state.main.calendarData,
  stopApiCallTimer: state.main.stopApiCallTimer,
});
export default connect(mapStateToProps)(AppContainer);
